export const QuestionTypes = {
  SELECT: 'question_select',
  BANDED: 'question_banded',
  STOCK: 'question_stock',
  UPLOAD: 'question_upload'
};
